import {
  Component,
  computed,
  inject,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MatBottomSheet, MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { map } from 'rxjs/operators';

import { AuthService } from '../../../services/auth.service';
import { SectorPickerSheetComponent } from './sector-picker-sheet.component';

@Component({
  selector: 'app-bottom-nav',
  imports: [
    RouterLink,
    RouterLinkActive,
    MatIconModule,
    MatRippleModule,
    MatBottomSheetModule,
  ],
  templateUrl: './bottom-nav.component.html',
  styleUrls: ['./bottom-nav.component.scss'],
})
export class BottomNavComponent {
  private readonly breakpoints = inject(BreakpointObserver);
  private readonly authService = inject(AuthService);
  private readonly bottomSheet = inject(MatBottomSheet);

  protected readonly isMobile = toSignal(
    this.breakpoints.observe('(max-width: 959.98px)').pipe(map((r) => r.matches)),
    { initialValue: false },
  );

  protected readonly isAuthenticated = this.authService.isAuthenticated;

  protected readonly profileLink = computed(() =>
    this.isAuthenticated() ? '/profile' : '/login',
  );

  protected readonly profileLabel = computed(() =>
    this.isAuthenticated() ? 'Profilo' : 'Accedi',
  );

  protected openSectorPicker(): void {
    this.bottomSheet.open(SectorPickerSheetComponent);
  }
}
